import React from 'react';
import './Spinner.css';

/**
 * Segment Spinner component based on the provided design
 * 
 * @param {Object} props
 * @param {number|string} props.size - Size of the spinner in pixels or as "small", "medium", "large"
 * @param {string} props.label - Optional loading text to display
 * @param {string} props.color - Optional color for the spinner (defaults to #333333)
 * @param {boolean} props.overlay - Whether to display with a background overlay
 */
const Spinner = ({ 
  size = 20, 
  label,
  color = "#333333",
  overlay = false 
}) => {
  // Convert string size values to numbers
  let sizeValue = size;
  if (typeof size === 'string') {
    switch (size.toLowerCase()) {
      case 'small':
        sizeValue = 25; // Smaller size for "small" option
        break;
      case 'medium':
        sizeValue = 35; // Medium size
        break;
      case 'large':
        sizeValue = 45; // Larger size option
        break;
      case 'tiny':
        sizeValue = 15; // Extra small option
        break;
      default:
        sizeValue = 35; // Default if string value is not recognized
    }
  }
  
  return (
    <div className={`spinner-container ${overlay ? 'spinner-overlay' : ''}`}>
      <div className="segment-spinner-wrapper" style={{ width: sizeValue, height: sizeValue }}>
        <svg 
          width={sizeValue} 
          height={sizeValue} 
          viewBox="0 0 50 50" 
          xmlns="http://www.w3.org/2000/svg"
          className="segment-spinner"
        >
          {/* 12 segments with varying opacity */}
          <g>
            <rect x="23.5" y="5" width="3" height="10" fill={color} />
            <rect x="23.5" y="5" width="3" height="10" fill={color} transform="rotate(30 25 25)" opacity="0.91" />
            <rect x="23.5" y="5" width="3" height="10" fill={color} transform="rotate(60 25 25)" opacity="0.83" />
            <rect x="23.5" y="5" width="3" height="10" fill={color} transform="rotate(90 25 25)" opacity="0.75" />
            <rect x="23.5" y="5" width="3" height="10" fill={color} transform="rotate(120 25 25)" opacity="0.67" />
            <rect x="23.5" y="5" width="3" height="10" fill={color} transform="rotate(150 25 25)" opacity="0.58" />
            <rect x="23.5" y="5" width="3" height="10" fill={color} transform="rotate(180 25 25)" opacity="0.5" />
            <rect x="23.5" y="5" width="3" height="10" fill={color} transform="rotate(210 25 25)" opacity="0.42" />
            <rect x="23.5" y="5" width="3" height="10" fill={color} transform="rotate(240 25 25)" opacity="0.33" />
            <rect x="23.5" y="5" width="3" height="10" fill={color} transform="rotate(270 25 25)" opacity="0.25" />
            <rect x="23.5" y="5" width="3" height="10" fill={color} transform="rotate(300 25 25)" opacity="0.17" />
            <rect x="23.5" y="5" width="3" height="10" fill={color} transform="rotate(330 25 25)" opacity="0.08" />
          </g>
        </svg>
      </div>
      {label && <div className="spinner-label">{label}</div>}
    </div>
  );
};

export default Spinner;